var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Home50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E8EAF6",
    d: "M42 39L6 39 6 23 24 6 42 23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5CAE9",
    d: "M39 21L34 16 34 9 39 9zM6 39H42V44H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B71C1C",
    d: "M24 4.3L4 22.9 6 25.1 24 8.4 42 25.1 44 22.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#D84315",
    d: "M18 28H30V44H18z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#01579B",
    d: "M21 17H27V23H21z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8A65",
    d: "M27.5,35.5c-0.3,0-0.5,0.2-0.5,0.5v2c0,0.3,0.2,0.5,0.5,0.5S28,38.3,28,38v-2C28,35.7,27.8,35.5,27.5,35.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Home50);
export default __webpack_public_path__ + "static/media/icons8-home-50.c236fe93e71405649acb72bedc954983.svg";
export { ForwardRef as ReactComponent };